import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import selector from './toolingEditor.selector';
import { setSelected } from '../Construction/construction.reducer';

import SelectEdit from '../../components/SelectEdit';

import { availableType } from '../../types/available.types';
import { infoShape } from '../../types/info.types';

import { Info } from './ToolingEditor.styles';

class WidthEditor extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    setSelected: PropTypes.func.isRequired,
    available: PropTypes.arrayOf(availableType),
    info: infoShape,
    selected: PropTypes.number,
    translationsData: PropTypes.object
  }

  static defaultProps = {
    available: [],
    selected: null,
    info: null,
    translationsData: null,
  }

  handleToolingChange = (value) => {
    this.props.setSelected('tooling', value);
  }

  render() {
    return (
      this.props.loaded && this.props.selected ? (
        <>
          <SelectEdit
            selected={this.props.selected}
            loaded={this.props.loaded}
            title={this.props.info.name}
            info={this.props.info}
            onChange={this.handleToolingChange}
            options={this.props.available.map((el) => ({
              id: el.id,
              value: `${el.attributes.value}`
            }))}
          />
          {
            this.props.selected === 2 ? (
              <Info>
                {this.props.translationsData && this.props.translationsData.color_of_tooling_can_be_set
                  ? this.props.translationsData.color_of_tooling_can_be_set
                  : 'color_of_tooling_can_be_set'}
              </Info>
            ) : null
          }

        </>
      ) : <SelectEdit loading />
    );
  }
}

const mapDispatchToProps = {
  setSelected
};

export default connect(selector, mapDispatchToProps)(WidthEditor);
